import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class ApproverRequest extends BaseEntity {
  scenarioId?: number;
  type?: string;
}
